// Import and register all your controllers from the importmap via controllers/**/*_controller
import AIAssistantController from "./ai_assistant_controller"
import { application } from "./application"
import AutosaveController from './autosave_controller'
import DraftContentController from "./draft_content_controller"
import PDFPreviewController from "./pdf_preview_controller"
import RawNotesContentController from "./raw_notes_content_controller"

application.register('ai-assistant', AIAssistantController)
application.register('autosave', AutosaveController)
application.register('pdf-preview', PDFPreviewController)
application.register('raw-notes-content', RawNotesContentController)
application.register('draft-content', DraftContentController)
